export const EXTENDED_SIDEBAR_WIDTH = 234;
export const SIDEBAR_HEIGHT_PERCENT_PORTRAIT = '48.5';
export const SIDEBAR_TRANSITION = `${SIDEBAR_TRANSITION_MS}ms ease-in-out`;
export const SIDEBAR_TRANSITION_MS = 150;
export const SIDEBAR_WIDTH = 300;
export const TOGGLE_BUTTON_HEIGHT = 60;
export const TOGGLE_BUTTON_WIDTH = 20;

export default {
  EXTENDED_SIDEBAR_WIDTH,
  SIDEBAR_HEIGHT_PERCENT_PORTRAIT,
  SIDEBAR_TRANSITION,
  SIDEBAR_WIDTH,
  TOGGLE_BUTTON_HEIGHT,
  TOGGLE_BUTTON_WIDTH,
};
